/* eslint-disable import/prefer-default-export */
import { AssistantStatus, AssistantTable } from '@src/types/assistant';

/**
 * Sort assistants by status priority and creation date
 * Priority order: ACTIVE > TESTING > INACTIVE > DRAFTED
 * Secondary sort: createdAt (newest first)
 * @param assistants - Array of assistants to sort
 * @returns Sorted array (does not mutate original)
 */
export function sortAssistants(assistants: AssistantTable[]): AssistantTable[] {
  // Define status priority order: ACTIVE=1, TESTING=2, INACTIVE=3, DRAFTED=4
  const statusPriority: Record<string, number> = {
    [AssistantStatus.ACTIVE]: 1,
    [AssistantStatus.TESTING]: 2,
    [AssistantStatus.INACTIVE]: 3,
    [AssistantStatus.DRAFTED]: 4,
  };

  return [...assistants].sort((a, b) => {
    const priorityA = statusPriority[a.status] || 999;
    const priorityB = statusPriority[b.status] || 999;

    // Primary sort: by status priority
    if (priorityA !== priorityB) {
      return priorityA - priorityB;
    }

    // Secondary sort: by createdAt (newest first)
    const dateA = new Date(a.createdAt).getTime();
    const dateB = new Date(b.createdAt).getTime();
    return dateB - dateA;
  });
}
